import * as React from 'react';
import { Instance } from 'mobx-state-tree';
import { TicketListTimeFilterModel, TicketListStateFilterModel, ProgressStateModel, TicketListTypeSelectorStore, OfferType } from 'eTip--common';

import { IStringFilterOption, ITicketListItem, ListPager, NoResultsLoginNeeded, TicketList, TicketListFilter, TicketListTypeSelector } from 'common--design-library';
import { SimpleBarWrapper as SimpleBar } from 'desktop--design-library';
import { FooterContainer } from '../footer/footerContainer';

import { translationForMts } from 'easit--localization';
import * as routing from 'easit--routing';

export interface ITicketListDataStore {
    loadDataAsync(isSilent: boolean): Promise<void>;
    isUserLogged: boolean;
    timeFilter: TicketListTimeFilterModel | null;
    stateFilter: TicketListStateFilterModel | null;
    offerTypeFilter: OfferType | null;
    timeFilterOptions: IStringFilterOption[];
    stateFilterOptions: IStringFilterOption[];
    offerTypeFilterOptions: { key: number, title: string }[];
    state: ProgressStateModel;
    isLastActionSetFilter: boolean;
    tickets: ITicketListItem[];
    error: string;
    pager: { currentPage: number, pagesStart: number; pagesEnd: number; totalPages: number };
    setFilterAsync(timeFilter: TicketListTimeFilterModel, stateFilter: TicketListStateFilterModel, offerTypeFilter: OfferType): void; // in fact it returns Promise
    resetFilter(stateFilter: TicketListStateFilterModel): void;
    setPagerPageAsync(page: number): void;
}

export interface ITicketListProps {
    applicationStore: {
        ticketList: ITicketListDataStore,
        ticketListForVG: ITicketListDataStore | null,
        ticketListTypeSelector: Instance<typeof TicketListTypeSelectorStore> | null,
    };
}

export abstract class TicketListContainerBase extends React.Component<ITicketListProps> {
    private readonly testRoleMainPart = "ticket-list";

    constructor(props: ITicketListProps) {
        super(props);
    }

    abstract get store(): ITicketListDataStore;

    abstract get canShowPotentialWin(): boolean;

    abstract goToDetail(ticketId: string): void;

    private autoReload() {
        window.setTimeout(() => {
            this.store.loadDataAsync(true).then(() => { this.autoReload() });
        }, 30000)
    }

    componentWillMount() {
        this.store.loadDataAsync(false).then(() => { this.autoReload() });
    }

    render() {
        return (<SimpleBar
            className={`scroll-container hide-x-bar`}
            forceVisible={true} scrollToTop
        >
            <h1 className="p-1" data-test-role={`${this.testRoleMainPart}--header`}>{translationForMts().ticketList_Title}</h1>
            {this.props.applicationStore.ticketListTypeSelector && <TicketListTypeSelector
                items={this.props.applicationStore.ticketListTypeSelector.items}
                activeIndex={this.props.applicationStore.ticketListTypeSelector.activeIndex}
                onClick={(item, index) => { this.props.applicationStore.ticketListTypeSelector.setActiveItem(index); routing.push(item.path); }}
            />
            }
            <div className="h-100 scroll-container-padding">
                {this.store.isUserLogged && <>
                    <TicketListFilter
                        timeFilter={this.store.timeFilter}
                        stateFilter={this.store.stateFilter}
                        offerTypeFilter={this.store.offerTypeFilter}
                        timeFilterOptions={this.store.timeFilterOptions}
                        stateFilterOptions={this.store.stateFilterOptions}
                        offerTypeFilterOptions={this.store.offerTypeFilterOptions}
                        canShowInProgress={this.store.state === ProgressStateModel.Loading && this.store.isLastActionSetFilter}
                        onSubmitClick={(timeFilter: TicketListTimeFilterModel, stateFilter: TicketListStateFilterModel, offerTypeFilter: number) => { this.store.setFilterAsync(timeFilter, stateFilter, offerTypeFilter); }}
                    />
                    <TicketList
                        tickets={[...this.store.tickets]}
                        onGoToDetail={this.goToDetail}
                        error={this.store.error}
                        state={this.store.state}
                        canShowTicketNumber={true}
                        canShowPotentialWin={this.canShowPotentialWin}
                        pager={<ListPager
                            canShowLeftArrow={this.store.pager.currentPage > 1}
                            canShowRightArrow={this.store.pager.currentPage < this.store.pager.totalPages}
                            pagesStart={this.store.pager.pagesStart}
                            pagesEnd={this.store.pager.pagesEnd}
                            currentPage={this.store.pager.currentPage}
                            totalPages={this.store.pager.totalPages}
                            leftArrowClick={() => { this.store.setPagerPageAsync(this.store.pager.currentPage - 1) }}
                            rightArrowClick={() => { this.store.setPagerPageAsync(this.store.pager.currentPage + 1) }}
                            pageClick={(pageIndex: number) => { this.store.setPagerPageAsync(pageIndex); }}
                            className="p-2"
                        />}
                    />
                </>}
                {!this.store.isUserLogged && <NoResultsLoginNeeded message={translationForMts().myTickets_Login} testRoleMainPart={this.testRoleMainPart} />}
            </div>
            <FooterContainer canShow={true} />
        </SimpleBar>)
    }
}
